function initSwiper() {
  const swipersObj = document.querySelectorAll('.swiper-container');

  swipersObj.forEach(swipersObjNow => {
    const controls = swipersObjNow.getAttribute('aria-controls');
    const visiblePcSlides = swipersObjNow.getAttribute('data-pc-columns');
    const visibleMSlides = swipersObjNow.getAttribute('data-m-columns');
    const pcPagination = swipersObjNow.getAttribute('data-pc-pagination');
    const mPagination = swipersObjNow.getAttribute('data-m-pagination');
    const pcMargin = swipersObjNow.getAttribute('data-pc-margin');
    const mMargin = swipersObjNow.getAttribute('data-m-margin');
    const pcIsOpenSwiper = swipersObjNow.getAttribute('data-pc-open-swiper');
    const mIsOpenSwiper = swipersObjNow.getAttribute('data-m-open-swiper');
    const speed = swipersObjNow.getAttribute('data-speed');
    const pcLoop = swipersObjNow.getAttribute('data-pc-loop');
    const mLoop = swipersObjNow.getAttribute('data-m-loop');
    const pcCenteredSlides = swipersObjNow.getAttribute('data-pc-centered-slides');
    const mCenteredSlides = swipersObjNow.getAttribute('data-m-centered-slides');
    const pcDotImg = swipersObjNow.getAttribute('data-pc-dot-img');
    let autoplayEnabled = swipersObjNow.getAttribute('data-autoplay') === 'true';

    let centeredSlides = false,loop = true,isSwiper = true,pagination = false,navigation=false,mSlidesPerView = 'auto',pcSlidesPerView = 'auto';
    if(window.innerWidth < 750){
      if(mIsOpenSwiper != 'true'){
        isSwiper = false;
      }
      if(mLoop == 'false'){
        loop = false
      }
      if(mCenteredSlides == 'true'){
        centeredSlides = true
      }
      if(mPagination == 'dot'){
        pagination = {
          el: '#'+controls+' .swiper-pagination',
          clickable: true,
        };
      }else if(mPagination == 'arrows'){
        navigation = {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
      }
    }else{
      if(pcIsOpenSwiper != 'true'){
        isSwiper = false;
      }
      if(pcLoop == 'false'){
        loop = false
      }
      if(pcCenteredSlides == 'true'){
        centeredSlides = true
      }
      if(pcPagination == 'dot'){
        if(pcDotImg == 'true'){
          pagination = {
            el: '#'+controls+' .swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
              console.log(className);
              if(pcDotImg == 'true'){
                // 从slide获取对应的图片
                let bulletImage = swipersObjNow.querySelectorAll('.swiper-slide')[index].getAttribute('data-bullet-image');
                if(bulletImage){
                  swipersObjNow.querySelector('.swiper-pagination').classList.add('swiper-pagination-img-box');
                  return '<span class="' + className + ' swiper-pagination-img"><img src="' + bulletImage + '"></span>';
                }
                return '<span class="' + className + '" ></span>';
              }
            },
          };
        }else{
          pagination = {
            el: '#'+controls+' .swiper-pagination',
            clickable: true,
          };
        }
      }else if(pcPagination == 'arrows'){
        navigation = {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
      }
    }

    if(!isSwiper){
      document.querySelector('#'+controls).style.opacity = 1;
      document.querySelector('#'+controls+' .swiper-button-next').style.display = 'none';
      document.querySelector('#'+controls+' .swiper-button-prev').style.display = 'none';
      return;
    }

    if(autoplayEnabled){
      autoplayEnabled = {
        delay: speed * 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
        reverseDirection: false,
        waitForTransition: true
      };
    }

    if(visibleMSlides > 0){
      mSlidesPerView = parseFloat(visibleMSlides);
    }

    if(visiblePcSlides > 0){
      pcSlidesPerView = parseFloat(visiblePcSlides);
    }

    const mySwiper = new Swiper('#'+controls, {
      direction: 'horizontal',
      loop: loop,
      autoplay: autoplayEnabled,
      slidesPerView: mSlidesPerView,
      centeredSlides: centeredSlides,
      spaceBetween: parseInt(mMargin),
      breakpoints: {
        749: {
          slidesPerView: pcSlidesPerView,
          spaceBetween: parseInt(pcMargin)
        }
      },
      pagination: pagination,
      navigation: navigation,
      watchOverflow: true,
      scrollbar: false,
      on: {
        init: function() {
          document.querySelector('#'+controls).style.opacity = 1;
          if(navigation != false){
            document.querySelector('#'+controls+' .swiper-button-next').classList.remove('display-none')
            document.querySelector('#'+controls+' .swiper-button-prev').classList.remove('display-none')
          }
        }
      },
    });
  });
}
document.addEventListener('DOMContentLoaded', function () {
  initSwiper();
});